import React, { Component } from 'react';

import ImageSlider from './ImageSlider.js';
import Hammer from 'hammerjs';
import Filter from './Filter.js';
import ContactForm from './ContactForm.js';




class ImageView extends Component {

  constructor(props){
    super(props);

    // console.log('ip:',this.props.currentIp);

    if(!this.props){
      return false;
    }

    this.state = ({
      hoverId:false,
      mouse: {x:0, y:0},
      toggle:false,
      points:null,
      dots: [],
      panelOpen:false,
      newArea:{},
      zoom:1,
      moveImage: {x:0,y:0},
      showList:false,
      showFilter:false,
      sortOn:'title',
      filterOn:false,
      imgId: this.props.activeImgId,
      objects:this.props.data.items,
      formOpen:false,
      clickId:props.clickedId || false
    });

    this.infoFields = [ "price", "fee", "rooms", "property", "living_space", "yard_area", "operating_cost", "biarea" ];

    this.img = this.props.data.project.images[this.state.imgId];

    this.hoverHouse = this.hoverHouse.bind(this);
    this.clickHouse = this.clickHouse.bind(this);
    this.mouseOutInfo = this.mouseOutInfo.bind(this);
    this.toggleList = this.toggleList.bind(this);
    this.toggleFilter = this.toggleFilter.bind(this);
    this.toggleForm = this.toggleForm.bind(this);
    this.getFilterValues = this.getFilterValues.bind(this);
    this.clearFilter = this.clearFilter.bind(this);
    this.filterList = this.filterList.bind(this);
    this.filterItems = this.filterItems.bind(this);
    this.showArea = this.showArea.bind(this);
    this.closeInfo = this.closeInfo.bind(this);
    this.updateMousePos = this.updateMousePos.bind(this);
    this.scrollImage = this.scrollImage.bind(this);
    this.zoomOnClick = this.zoomOnClick.bind(this);
    this.getAreaStatusClass = this.getAreaStatusClass.bind(this);
    this.getStatus = this.getStatus.bind(this);
    this.getItemText = this.getItemText.bind(this);
    this.getInfoFields = this.getInfoFields.bind(this);
    this.viewNextImage = this.viewNextImage.bind(this);
    this.sortData = this.sortData.bind(this);
    this.handleOptionChange = this.handleOptionChange.bind(this);
    this.highlightAreas = this.highlightAreas.bind(this);

    this.lastY = 0;

    this.mouseDownPos = {x:0,y:0};
    this.mouseUpPos = {x:0,y:0};

    this.maxDistX = 400;
    this.maxDistY = 400;

    this.diffX = 0;
    this.diffY = 0;

  }



  componentWillUpdate(props, state){

    if(!state.filterValues){
      this.setState({
        filterValues: this.getFilterValues()
      })
    }

    if(this.state.imgId !== state.imgId ){
      this.img = this.props.data.project.images[state.imgId];

      var img = new Image();
      img.src = this.img;

      img.onload = function(){
        this.setState({
          loading:false,
        })
      }.bind(this)
    }
  }

  componentDidUpdate(){
    let _areaWrapper = document.getElementById('area');
    let _areaData = _areaWrapper.getBoundingClientRect();
    this.diffX = _areaData.x + window.scrollX;
    this.diffY = _areaData.y + window.scrollY;

    this.diffX = isNaN(this.diffX) ? 0 : this.diffX;
    this.diffY = isNaN(this.diffY) ? 0 : this.diffY;
  }



  componentDidMount(){

    var _areaWrapper = document.getElementById('area');
    var _view = document.querySelectorAll('.view')[0];



    setTimeout(function () {
      this.wrapperWidth = _areaWrapper.offsetWidth;
      this.pageWidth = document.body.offsetWidth;
      this.wrapperHeight = _areaWrapper.offsetHeight;
      this.pageHeight = document.body.offsetHeight;
    }.bind(this), 500);

    var options = {
      drag: true,
      prevent_default: false,
      drag_block_horizontal: true,
      hold: false,
      threshold: 10,
      release: true
    };

    var mc = new Hammer(_areaWrapper, options);
    // var mc2 = new Hammer(_areaWrapper, options);

    mc.on('pinch', function(ev) {
      _view.style.cssText = 'pointer-events:;none'
    }.bind(this))

    let startImgPos = {x:0,y:0};
    mc.on('panstart', function(ev) {
      startImgPos.x = this.state.moveImage.x;
      startImgPos.y = this.state.moveImage.y;
    }.bind(this));

    // Zooms on Scroll
    // _areaWrapper.addEventListener('wheel', function(e){
    //   this.scrollImage(e);
    // }.bind(this));

    mc.get('pinch').set({ enable: true });

    // mc.on('pinch', function(ev) {
    //   // this.scrollImage(ev);
    //
    //   let scale = ev.scale < 1 ? 1 : ev.scale;
    //   this.setState({
    //     zoom:scale
    //   })
    //
    //
    // }.bind(this))

    mc.on('panmove', function(ev) {
      this.maxDistX = this.wrapperWidth/2 * this.state.zoom;
      this.maxDistY = this.wrapperHeight/2 * this.state.zoom;

       if(this.state.zoom === 1 || this.state.hoverId ){
         return false;
       }

       // let _x = (this.state.moveImage.x + ev.deltaX/5);
       let _x = (startImgPos.x + ev.deltaX);
       // let _y = (this.state.moveImage.y + ev.deltaY/5);
       let _y = (startImgPos.y + ev.deltaY);

       // if (_x < 0 ){
       //   _x = ( (this.maxDistX + _x) < 0 ) ? -this.maxDistX : _x;
       // }
       // if (_x > 0 ){
       //   _x = ( (this.maxDistX - _x) < 0 ) ? this.maxDistX : _x;
       // }
       //
       // if (_y < 0 ){
       //   _y = ( (this.maxDistY + _y) < 0 ) ? -this.maxDistY : _y;
       // }
       // if (_y > 0 ){
       //   _y = ( (this.maxDistY - _y) < 0 ) ? this.maxDistY : _y;
       // }

       this.setState({
            moveImage: {
              x: _x,
              y: _y
            }
          });
    }.bind(this));

    let hotspots = document.querySelectorAll('.hotspots')[0];
    hotspots.classList.add('mouse-is-moving');

    let timeout = setTimeout(function(){
        hotspots.classList.remove('mouse-is-moving');
    }, 3000);

  }

  updateMousePos(_x, _y){
    // console.log('update mouse pos x: '+ _x + ', y: ' + _y + ', diffX: ' + this.diffX+ ', diffY: ' + this.diffY);
    let mouseX = _x - this.diffX;
    let mouseY = _y - this.diffY;
    const infoSize = {w: 250, h:250};

    if(mouseX > (this.pageWidth - this.diffX - infoSize.w) ){
      mouseX = mouseX - (infoSize.w/1.5);
    }
    else if(mouseX < infoSize.w ){
      mouseX = mouseX + (infoSize.w * 0.25);
    }

    if(mouseY > (this.pageHeight - this.diffY*2 - infoSize.h) ){
      mouseY = mouseY - infoSize.h;
    }

    if( isNaN(mouseX) || isNaN(mouseY) ){
      return false;
    }

    mouseX = isNaN(mouseX) ? 0 : mouseX;
    mouseY = isNaN(mouseY) ? 0 : mouseY;

    this.setState({
      mouse:{
        x: mouseX,
        y: mouseY
      }
    });
  }

  showArea(e){
    let _target = e.currentTarget;
    let _id = _target.getAttribute('objectid');
    let _svg = document.getElementsByClassName('hotspots')[0];
    let _area = document.getElementById('area_' + _id);

    if( _target.classList.value && _target.classList.value.match('different-view')){
      this.viewNextImage();
    }

    let count = 0;
    const checkForArea = setInterval(function(){
      count++;
      _area = document.getElementById('area_' + _id);

      if(_area){

        clearInterval(checkForArea);

        this.toggleList();
        _svg.classList.add('highlight-mode');
        _area.classList.add('highlight');

        setTimeout(function () {
          _area.classList.remove('highlight');
          _svg.classList.remove('highlight-mode');

        }, 3500);

      }
      else if (count > 10) {
        clearInterval(checkForArea);
      }
    }.bind(this),300)

    this.setState({
      moveImage: {x:0,y:0},
      zoom: 1
    })
  }

  highlightAreas(e){
    // let _svg = document.getElementsByClassName('hotspots')[0];
    let target = e.currentTarget;
    let thisMouse = {x:e.pageX, y:e.pageY}
    let mouseIsMoving = true;
    // console.log('mouse is moving');
    if(!target.classList.contains('mouse-is-moving')){
      target.classList.add('mouse-is-moving');
    }

    clearTimeout(timeout);
    let timeout = setTimeout(function(){
      if(target.classList.contains('mouse-is-moving')){
        target.classList.remove('mouse-is-moving');
      }
      // console.log('not moving');

    }, 3000);




  }

  clickHouse(_id){
//
//     console.log('ip: ', this.props.currentIp, ' öppnar den här');
// console.log('- - - - - - - - - - - - -');

    this.props.handleHouseClick(_id, this.props.currentIp);

    this.setState({
      clickId: 'text-' + _id,
      hoverId: false
    });
  }

  hoverHouse(e, _id){

    if ("ontouchstart" in document.documentElement){
      // this.clickHouse(_id);
    }

    if(this.state.clickId){
      return false;
    }

    let _x = e.pageX;
    let _y = e.pageY;

    this.updateMousePos(_x,_y);

    this.setState({
      hoverId: 'text-' + _id,
    });
  }

  mouseOutInfo(e){
    this.setState({
      hoverId: false
    })
  }

  closeInfo(){
    this.setState({
      clickId: false
    })
  }

  toggleForm(e){
    e.preventDefault();
    let id = e.target.getAttribute('data-id');

    this.setState({
      formOpen: id
    })
  }

  toggleList(){
    let showList = (this.state.showList) ? false : true;

    this.setState({
      showList: showList
    })
  }

  toggleFilter(forcedVal){
    let showFilter = (this.state.showFilter) ? false : true;
    if(forcedVal === 'hide'){
      showFilter = false;
    }
    else if (forcedVal === 'show'){
      showFilter = true;
    }

    this.setState({
      showFilter: showFilter
    })
  }

  clearFilter(){
    this.setState({
      filterValues: this.getFilterValues()
    });

    this.toggleFilter('hide');
    this.filterList();
  }

  handleOptionChange(e){
    let val = e.currentTarget.value;

    this.setState({
      sortOn: val
    });

    var sortedList = this.sortData(this.props.data.items, val);

    this.filterItems(this.state.filterValues, sortedList);

  }

  sortData(items, prop) {

    let sortedItems = Object.keys(items).sort(function(a, b) {

      if(!items[a][prop] || !items[b][prop]){
        var nameA = parseInt(items[a].info[prop].text); // ignore upper and lowercase
        var nameB = parseInt(items[b].info[prop].text); // ignore upper and lowercase
      }
      else {
        var nameA = items[a][prop].toUpperCase(); // ignore upper and lowercase
        var nameB = items[b][prop].toUpperCase(); // ignore upper and lowercase
      }

    if (nameA < nameB) {
      return -1;
    }
    if (nameA > nameB) {
      return 1;
    }

    // names must be equal
    return 0;
    });

    return sortedItems;
  }

  filterItems(filterValues, filterItems){

    let filterInactive = true;

    const sortedObjectIds = filterItems.filter((key,index, data) => {
      const _item = this.props.data.items[key];
      const _roomsTitle = _item.info.rooms.title;
      const _rooms = _item.info.rooms.text;
      const _status = _item.status;

      let _statusNiceName = _status;
      switch (_status) {
        case "available":
          _statusNiceName = 'Tillgängliga';
          break;
        case "reserved":
          _statusNiceName = 'Reserverade';
          break;
        case "sold":
          _statusNiceName = 'Sålda';
          break;
        default:

      }

      const valuesObj = filterValues[_roomsTitle];
      const statusesObj = filterValues['Status'];

      let allValuesInactive = Object.keys(valuesObj).every(function(k){ return valuesObj[k] === false });
      let allStatusesInactive = Object.keys(statusesObj).every(function(k){ return statusesObj[k] === false });

      filterInactive = (allValuesInactive && allStatusesInactive)? true : false;

      let filterResult = (
        (valuesObj[_rooms] && statusesObj[_statusNiceName]) ||
        (valuesObj[_rooms] && allStatusesInactive) ||
        (statusesObj[_statusNiceName] && allValuesInactive) ||
        (allValuesInactive && allStatusesInactive) );

      return filterResult;

    });

    let filterStatus = false;

    // if(sortedObjectIds.length !== Object.keys(this.props.data.items).length || Object.keys(this.props.data.items).length === 1 ){
    if( !filterInactive ){
      filterStatus = true;
    }

    let sortedObjects = {};

    sortedObjectIds.map((val) => {
      sortedObjects[val] = this.props.data.items[val];
    });

    this.setState({
      filterOn: filterStatus,
      objects: sortedObjects
    })
  }

  filterList(filterType, id, val){
    let newFilterValues = this.state.filterValues;
    if(filterType){
      newFilterValues[filterType][id] = val;
    }
    else {
      newFilterValues = this.getFilterValues()
    }

    var sortedList = this.sortData(this.props.data.items, this.state.sortOn);

    this.setState({
      filterValues: newFilterValues
    });

    this.filterItems(newFilterValues, sortedList);

  }

  scrollImage(e){

    alert('deltaY', e.scale);
    let dY = e.deltaY *-1;
    let _scale = this.state.zoom;

    if ( dY > 0){
      _scale += .1;
      _scale = (_scale > 4) ? 4:_scale;
    }
    else {
      _scale -= .1 ;
      _scale = (_scale < 1) ? 1:_scale;

      this.setState({
        moveImage: {x:0, y:0}
      });
    }

    if( _scale===1 || _scale === 4){

    }
    else {
      e.preventDefault();
    }

    this.setState({
      zoom: _scale
    })
  }

  zoomOnClick(_dir){
    let _scale = this.state.zoom;
    let _moveImage= this.state.moveImage;


    if(_dir === '+'){
      _scale += .5;
      _scale = (_scale > 4) ? 4:_scale;

    }
    else {
      _scale -= .5;
      _scale = (_scale < 1) ? 1:_scale;

      if(_scale === 1){
        _moveImage= {x:0, y:0}
      }

    }

    this.setState({
      zoom: _scale,
      moveImage:_moveImage
    })

  }

  getStatus(area){
    const areaStatus = this.props.data.items[area].status;

    let _string = '';

    switch (areaStatus) {
      case "available":
        _string = 'Tillgänglig';
        break;
      case "reserved":
        _string = 'Reserverad';
        break;
      case "sold":
        _string = 'Såld';
        break;
      default:

    }

    return (
      <span className={ areaStatus + ' status'}>
        {_string}
      </span>
    );
  }

  getItemText(area){
    const areaText = this.props.data.items[area].text;
    if( areaText.length > 0 ){
      return (
        <p>{areaText}</p>
      );
    }
  }

  getInfoFields(area){
    const objects = this.props.data.items[area];
    return (
      <ul>

        {
          this.infoFields.map((info, _key)=>{
            let _text = objects.info[info].text;
            // if(_text.length > 0 && _text != '-'){
            if(_text.length > 0){
              return (
                <li key={'info-list-' +_key} title={objects.info[info].title}>{_text}</li>
              );
            }
          })
        }


      </ul>
    );
  }

  getAreaStatusClass(area){
    const areaStatus = this.props.data.items[area].status;

    return areaStatus;
  }

  getFilterValues(){

    let roomValues = [];
    let filterObj = {};

    if(!this.props.data.items){
      return filterObj;
    }


    Object.keys(this.props.data.items).map((itemId, index)=>{

      const thisItem = this.props.data.items[itemId];
      const roomsAvailable = thisItem.info.rooms.text;

      if( index === 0 ){
        filterObj[thisItem.info.rooms.title] = {}
      }

      if( roomValues.indexOf(roomsAvailable) === -1 ){

        filterObj[thisItem.info.rooms.title][roomsAvailable] = false;

        roomValues.push(roomsAvailable);
      }
    })


    filterObj["Status"] = {
        "Tillgängliga":false,
        "Reserverade":false,
        "Sålda":false,
      }


    return filterObj;

  }

  viewNextImage(){

    let countImages = Object.keys(this.props.data.project.images).length;

    let nextImgId = parseInt(this.state.imgId.replace('image', ''));
    if ( countImages - nextImgId === 0) {
      nextImgId = 1;
    }
    else {
      nextImgId += 1;
    }


    this.setState({
      imgId: "image" + nextImgId,
      loading:true
    })

  }

  render() {

    let src = this.img;
    // let objects = (this.props.data.items) ? this.props.data.items: {};
    let objects = (this.state.objects) ? this.state.objects: {};
    let _filterValues = this.state.filterValues ? this.state.filterValues : {};


    let style = {
      transform: 'translateZ(0) translate(' + this.state.moveImage.x + 'px, ' + this.state.moveImage.y + 'px) scale(' + this.state.zoom + ')',
      transition: 'transform .2s ease'
    };

    let mousePos = {
      x: this.state.mouse.x,
      y: this.state.mouse.y
    }

    let _image = this.state.imgId;
    let countImages = Object.keys(this.props.data.project.images).length;

    return (
    <div className={this.state.filterOn ? "filter-on relative" : "relative"}>

      <div className={(this.state.showList) ? 'list-wrapper modal show' : 'modal list-wrapper'}>
        <div className="icon icon-close" onClick={this.toggleList}></div>

        <div className="container">
          <div className="container__header">
            <h3>{this.props.data.project.title}</h3>


            <div className={this.state.filterOn ? "filter-info" : "hidden"}>
              <p>Filtret är aktivt så listan visar enbart objekt som matchar din filtrering.</p>
              <div className="flex-row">
                <div onClick={this.toggleFilter} className="btn--mini">Visa filter</div>
                <div onClick={this.clearFilter} className="btn--mini">Rensa filter</div>
              </div>
            </div>

            <div className="select-wrapper select-wrapper--small sort-options">
              <select onChange={this.handleOptionChange}>
                <option value="title">Namn</option>
                <option value="price">Pris</option>
                <option value="fee">Avgift</option>
                <option value="rooms">Rum</option>
                <option value="living_space">Boarea</option>
                <option value="yard_area">Tomtarea</option>
                <option value="status">Status</option>
              </select>
            </div>

          </div>
          <ul className="list--tight">
          {
            Object.keys(objects).map((key)=> {
              let _points = objects[key].points ? objects[key].points[_image] : null;

              let _className = 'list__object';
              if(!objects[key].points ){
                _className += ' hidden';
              }
              else if (objects[key].points && !_points) {
                _className += ' different-view';

              }
              return (
                <li key={key}
                  onClick={this.showArea }
                  className={_className}
                  objectid={key}>
                  <div className={"status-dot " + objects[key].status }></div>

                  <span className="list__object__title">{objects[key].title}</span>


                  <div className="list__object__info">
                  <span>
                    <b>{objects[key].info.price.title}</b> : {objects[key].info.price.text}
                  </span>
                  <span>
                    <b>{objects[key].info.fee.title}</b> : {objects[key].info.fee.text}
                  </span>
                  <span>
                    <b>{objects[key].info.rooms.title}</b> : {objects[key].info.rooms.text}
                  </span>
                  <span>
                    <b>{objects[key].info.living_space.title}</b> : {objects[key].info.living_space.text}
                  </span>
                  <span>
                    <b>{objects[key].info.yard_area.title}</b> : {objects[key].info.yard_area.text}
                  </span>

                  </div>
                  <span className="list__object__link">Visa</span>
                </li>
              );
            })
          }
          </ul>


          <div className="flex-row list-availability">
            <div className="flex-row"><div className="status-dot available"></div>Tillgängliga</div>
            <div className="flex-row"><div className="status-dot reserved"></div>Reserverade</div>
            <div className="flex-row"><div className="status-dot sold"></div>Sålda</div>
          </div>


        </div>

      </div>




      <div className={(this.state.showFilter) ? 'modal show' : 'modal hide'}>
        <div className="icon icon-close" onClick={this.toggleFilter}></div>

        <div className="filter">

          {
            Object.keys(_filterValues).map((type) => {
              let values = _filterValues[type];

              return (
                <Filter key={'filter-'+type} title={type} toggleFilter={this.toggleFilter} onChange={this.filterList} filterValues={values}/>
              )
            })
          }
          <div className="filter__footer">
            <div onClick={this.toggleFilter} className="btn--small">Visa resultat</div>
            <div onClick={this.clearFilter} className="btn--small">Rensa filter</div>
          </div>
        </div>

      </div>


      <div id="area" className={this.props.data.project.reverseButtons ? "image-wrapper reverse" : "image-wrapper"} >

        <img alt="houses" style={style} className="main-image" src={src} />

        <div className="area-options">
          <div onClick={this.toggleList} className="btn--small btn--icon"><i className="fas fa-th-list"></i> Visa lista</div>
          <div onClick={this.toggleFilter} className="btn--small btn--icon"><i className="fas fa-sliders-h"></i> Filter</div>
          <div onClick={this.viewNextImage} className={(countImages > 1) ? "btn--small btn--icon" : "hidden"}><i className="fas fa-sync-alt"></i> Rotera vy</div>
        </div>


        <div className="zoom-buttons">
          <div onClick={(e)=>this.zoomOnClick('+')} className="btn zoom-in"><i className="fas fa-plus"></i></div>
          <div onClick={(e)=>this.zoomOnClick('-')} className="btn zoom-out"><i className="fas fa-minus"></i></div>
        </div>

        <div className="hotspots" onMouseMove={this.highlightAreas}>
          <svg style={style} xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
             viewBox={this.props.viewBox}>
            {
              Object.keys(objects).map((area,key)=>{
                let _points = objects[area].points ? objects[area].points[_image] : null;
                return (
                  <g key={'area_' +key} id={'area_' + objects[area].id} className={this.props.data.items[area].status}>
                    <polygon points={_points}
                    onMouseMove={(e)=>this.hoverHouse(e, objects[area].id)}
                    onClick={(e)=>this.clickHouse(objects[area].id)}
                    onMouseLeave={this.mouseOutInfo} />
                  </g>
                )

              })
            }
          </svg>
          <div className="info-wrapper">
            {
              Object.keys(objects).map((area, key)=>{
                let hoverInfoStyle = {
                  top: mousePos.y,
                  left: mousePos.x,
                  transition: 'transform .2s ease'
                }
                return (
                  <div key={'wrapper-'+key} >
                    <ul style={hoverInfoStyle} className={(this.state.hoverId === 'text-' + objects[area].id ) ? 'show hover-info' : 'hiide hover-info'}>
                    <li className="list-title">{objects[area].title}</li>
                    {
                      this.infoFields.map((info, _key)=>{
                        let _text = (objects[area].info[info]) ? objects[area].info[info].text : '';
                        if(_text.length > 0){
                          return (
                            <li key={'hover-' +_key} title={objects[area].info[info].title}>{_text}</li>
                          );
                        }
                      })
                    }
                    </ul>

                    <div key={key} className={(this.state.clickId === 'text-' + objects[area].id ) ? 'show info' : 'hide info'}>
                      <ImageSlider />
                      <div className="icon icon-close" onClick={this.closeInfo}></div>

                      <h2>{objects[area].title} </h2>
                      {this.getItemText(area)}
                      {this.getStatus(area)}

                      {this.getInfoFields(area)}
                      <div className={this.state.formOpen === objects[area].id ? "": "hidden"}>
                        <ContactForm
                          projectName={this.props.data.project.title}
                          objectName={objects[area].title}
                          email={objects[area].email || this.props.data.project.email}
                        />
                      </div>
                      <a className="btn--small" target="_blank" href={objects[area].link}>Planlösning<img src="../media/ritning.gif" className="pdf-icon"/></a>



                    </div>
                  </div>
                )
              })
            }
          </div>
        </div>
        <div className={ (this.state.loading) ? 'loading' : 'loading loaded'}></div>

      </div>
    </div>

    );
  }
}

export default ImageView;



// WEBPACK FOOTER //
// ./src/ImageView.js